// extracted by mini-css-extract-plugin
module.exports = {"panel":"_bc19911","panelHeader":"_b65cb0b","horizontalCardGroup":"_c913264"};